module.exports = __webpack_public_path__ + "img/OCBC-Banner.3a5db997.png";